import { useTranslation } from 'react-i18next';

import { ReactComponent as Icon } from '../../assets/icons/stationType.svg';

export default function () {
  const { t } = useTranslation('stationtypes');

  return <Icon className="MuiSvgIcon-root" alt={t('Stationstypen')} aria-label={t('Stationstypen')} />;
}
